import * as React from 'react';
import Modal, { BotaoSecundario } from '../../gps/Modal';
import { HistoricoCampoDataProps } from '..';
import { traduzirValor, foiTraduzido } from '../../gps/traducaoValores';

/* ============================================================================
   ModalHistorico - o "antes e depois" de uma linha do historico.

   Migrado do Dialog do MUI para o Modal do visual novo. Mesmo contrato de props,
   porque quem chama e o HistoricoGPS, que aparece dentro de outros seis modais.

   QUATRO COISAS QUE MUDARAM, E POR QUE:

   1. O cabecalho tinha `backgroundColor: common.black` com `color: common.black`
      - texto preto sobre fundo preto. Os titulos Campo/Antes/Pos existiam e nao
      apareciam. Aqui o cabecalho usa o tom `soft` dos outros cabecalhos do sistema.

   2. `Pos` virou `Depois`. "Pos" nao e abreviacao de nada em portugues.

   3. Antes e depois lado a lado com a MESMA largura, e o valor novo em negrito.
      A pergunta que traz alguem a esta tela e sempre "o que ficou valendo".

   4. Fim da paginacao. Um `dataCampo` e a lista de campos alterados em UM save:
      na politica, o caso mais extenso do sistema, sao no maximo algumas dezenas
      de linhas. Paginar dez em dez esconde o diff que a pessoa abriu para ler.
      A tabela rola; a contagem fica no titulo.

   O `!campoDataLista || campoDataLista.length === 0 &&` do arquivo antigo lia como
   `a || (b && c)`: com a lista `undefined` a expressao virava `true`, React
   descarta booleano, e a linha "Sem registros" nao aparecia justamente no caso em
   que ela era necessaria.
   ============================================================================ */

interface Props {
  campoDataLista?: Array<HistoricoCampoDataProps>;
  handleClickOpen: any;
  handleClose: any;
  open: any;
  setOpen: any;
}

export function ModalHistorico({ campoDataLista, handleClose, open }: Props) {
  const lista = campoDataLista || [];

  return (
    <Modal
      aberto={Boolean(open)}
      titulo="Alterações feitas"
      descricao={lista.length === 1 ? '1 campo alterado neste save' : `${lista.length} campos alterados neste save`}
      largura="max-w-[720px]"
      onFechar={handleClose}
      rodape={<BotaoSecundario onClick={handleClose}>Fechar</BotaoSecundario>}
    >
      <div className="max-h-[60vh] overflow-auto rounded-lg border border-line">
        <table className="w-full border-collapse text-[12px]">
          <thead className="sticky top-0 bg-soft">
            <tr>
              <th className="px-3 py-2 text-left font-bold">Campo</th>
              <th className="w-[30%] px-3 py-2 text-left font-bold">Antes</th>
              <th className="w-[30%] px-3 py-2 text-left font-bold">Depois</th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 && (
              <tr>
                <td colSpan={3} className="px-3 py-6 text-center text-faint">
                  Sem registros de alteração neste item.
                </td>
              </tr>
            )}
            {lista.map((linha, i) => (
              <tr key={`${linha.campo}-${i}`} className="border-t border-line align-top hover:bg-soft">
                <td className="px-3 py-1.5 font-semibold">{linha.campo}</td>
                {/* Sem modificador de opacidade no `decoration-`: os tokens --gps-*
                    sao cor completa, nao canais HSL, e `decoration-danger/60` nao
                    geraria regra nenhuma (falha muda do Tailwind). */}
                {/* VALOR TRADUZIDO, VALOR CRU NO `title` (10/09/2026, a pedido).

                    A auditoria mostrava o enum da API do Google - "BLOCKED",
                    "CROSS_PROFILE_COPY_PASTE_ALLOWED", "WHITELIST". Quem faz a
                    conferencia nao e quem escreveu a integracao, e dois desses
                    significam no sistema o OPOSTO do que a palavra sugere
                    ("WHITELIST" e o modo em que a Play Store fica BLOQUEADA).
                    Auditoria que exige traducao mental e auditoria lida errado.

                    O que se GRAVA nao muda: o enum continua no banco, e e ele
                    que vai para o Google e serve de prova. Isto e leitura - e o
                    valor cru fica a um passar de mouse. */}
                <td
                  className="px-3 py-1.5 text-muted-foreground line-through decoration-danger"
                  title={foiTraduzido(linha.antigo, linha.campo) ? String(linha.antigo) : undefined}
                >
                  {traduzirValor(linha.antigo, linha.campo) || '—'}
                </td>
                <td
                  className="px-3 py-1.5 font-semibold text-ink"
                  title={foiTraduzido(linha.novo, linha.campo) ? String(linha.novo) : undefined}
                >
                  {traduzirValor(linha.novo, linha.campo) || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
}
